module.exports = __webpack_public_path__ + "static/img/b_2.982f2c3a.png";